export default __webpack_public_path__ + "static/media/saltlogo.3be3ae42.svg";